<template>
    <div class="c-loader">
        <i class="fal fa-circle-notch fa-spin" aria-hidden="true"></i> Loading
    </div>
</template>

<script>
    export default {
        name: "Loader"
    }
</script>

<style scoped>

</style>
